module.exports = __webpack_public_path__ + "static/media/c.01843351.svg";